import React, { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  Theme,
  Container,
} from "@material-ui/core";
import { BackButton } from "components";
import _ from "lodash";
import Zone from "typing/Zone";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}));

interface Props {
  title: string;
  subtitle: string;
  defaultValues?: Zone;
  onFinish: (values: Zone) => Promise<void>;
}

const ZoneForm: React.FC<Props> = ({
  title,
  subtitle,
  defaultValues,
  onFinish,
}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const { register, errors, trigger, getValues } = useForm({
    defaultValues,
  });

  const handleFinish = useCallback(async () => {
    try {
      setLoading(true);
      if (await trigger()) {
        await onFinish(getValues());
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [trigger, getValues, onFinish]);

  const hasError = (fieldName: string) => !!_.get(errors, fieldName);

  return (
    <Container maxWidth="md" className={classes.root}>
      <Card>
        <form autoComplete="off" noValidate>
          <CardHeader title={title} subheader={subtitle} />
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth
                  helperText="Please specify the zone name"
                  label="Name"
                  margin="dense"
                  name="name"
                  variant="outlined"
                  inputRef={register({ required: true })}
                  error={hasError("name")}
                />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardActions>
            <Button
              color="primary"
              variant="contained"
              onClick={handleFinish}
              disabled={loading}
            >
              Save
            </Button>
            <BackButton>Cancel</BackButton>
          </CardActions>
        </form>
      </Card>
    </Container>
  );
};

export default ZoneForm;
